module.exports = __webpack_public_path__ + "static/media/Dipesh.ea578336.jpg";